import { XIcon } from 'lucide-react'

export const HybridBrowsModal = () => {
function XList({items}: {items: string[]}) {
  return (
    <ul style={{listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: '.25rem'}}>
      {items.map((text) => (
        <li
          key={text}
          style={{display: 'grid', gridTemplateColumns: '1rem 1fr', gap: '.75rem', lineHeight: 1.6}}
        >
          <span style={{display: 'flex', alignItems: 'center', height: '1lh'}}>
            <XIcon style={{width: '1rem', height: '1rem'}} />
          </span>
          <span>{text}</span>
        </li>
      ))}
    </ul>
  );
}

    return (
        <div className="behandelingen-wrapper">
            <div style={{marginBottom: '2rem'}}>
                <h3 className="behandeling-title">Werkwijze </h3>
                <p>Aan de hand van je eigen natuurlijke wenkbrauwen wordt er eerst besproken wat de wensen en verwachtingen zijn en wat bij je gezicht past. Daarnaast bespreken we de contra-indicaties en vul je bij mij nog even een intakeformulier in.</p>
                <br/>
                <p>De wenkbrauwen en huid worden eerst voorbereid. Vervolgens ga ik door middel van brow mapping een tekening maken bij de wenkbrauwen, dan worden de haren en de huid met hybrid verf gekleurd en dit breng ik aan in een ombre effect. Vervolgens worden de wenkbrauwen voor een groot deel door middel van een milde hars in model geharst en daarna loop ik het na met een pincet. Tot slot worden de wenkbrauwen afgewerkt met concealer en in model gebracht met een brow gel.</p>

                <br/>
                <h3 className="behandeling-title">Nazorginstructies</h3>
                <p>Hoe lang de hybrid op de huid blijft zitten hangt af van je huidtype en lifestyle. Om zo lang mogelijk plezier van je wenkbrauwen te hebben is het advies om zo min mogelijk de wenkbrauwen te reinigen, scrubben, nat maken of gebruik van producten op oliebasis.</p>

                <br/>
<strong>24 uur na de behandeling:</strong>
<XList items={[
  'Geen make-up en gezichtsreinigers rondom het wenkbrauwgebied',
  'Vermijd anti-aging producten rondom de wenkbrauwen gedurende 2 à 3 dagen na de behandeling',
  'Gebruik 2 à 3 dagen geen bruiningsproducten',
]} />
<br/>
<strong>Indien mogelijk vermijd zoveel mogelijk:</strong>
<XList items={[
  'Sauna / zweten',
  'Verzorgingsproducten op oliebasis',
  'Peeling / scrubs rondom de wenkbrauwen',
  'Het aanraken van de wenkbrauwen',
]} />
            </div>

            <hr />
            <br/>
            <p>Voor meer uitleg, vragen en een prijs neem contact met mij op via onderstaande contactinformatie</p>
        </div>
    )
}